import styled from 'styled-components'

import { colors, fontWeights } from '@/styles'

const Anchor = styled.a`
  color: ${colors.link};
  font-weight: ${fontWeights.regular};
`

export default Anchor
